<div [style.width] = "width" style="height: 70px;">
    <div class="forms">
        <form class="date-wrapper" [formGroup]="dateForm">
            <mat-form-field class="formfield" appearance="fill" >
                <mat-label style="font-size: small;">
                    {{'CARDOPERATIONS_ONLINE_CHARGE_MAKE_PAYMENT_EXP_PLACEHOLDER_MM_LABEL' | translate}}
                </mat-label>
                <mat-select [formControl]="monthForm" name="month">
                <mat-option *ngFor="let month of months" [value]="month">{{month}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="formfield" appearance="fill">
                <mat-label style="font-size: small;">
                    {{'CARDOPERATIONS_ONLINE_CHARGE_MAKE_PAYMENT_EXP_PLACEHOLDER_YY_LABEL' | translate}}
                </mat-label>
                <mat-select [formControl]="yearForm" name="year">
                <mat-option *ngFor="let year of years" [value]="year">{{year}}</mat-option>
                </mat-select>
            </mat-form-field>
        </form>
    </div>
    <div class="error-msg">
        <p *ngIf="submitted && error">
            {{error}}
        </p>
    </div>
</div>